import { EMPTY_DEPARTMENT_NAME, GENERAL_APPLICATION_NAME} from 'rlink-recruiting/constants';

export default function groupJobsByDepartment (jobs) {
  return jobs.reduce((acc, job) => {
    if (job.departments.length === 0) {
      if (acc[EMPTY_DEPARTMENT_NAME]) {
        acc[EMPTY_DEPARTMENT_NAME].push(job);
      } else {
        acc[EMPTY_DEPARTMENT_NAME] = [job];
      }
    } else {
      job.departments.forEach(department => {
        if (department === GENERAL_APPLICATION_NAME) {
          if (acc[EMPTY_DEPARTMENT_NAME]) {
            acc[EMPTY_DEPARTMENT_NAME].push(job);
          } else {
            acc[EMPTY_DEPARTMENT_NAME] = [job];
          }
        } else if (acc[department]) {
          acc[department].push(job);
        } else {
          acc[department] = [job];
        }
      });
    }
    return acc;
  }, {});
}



// WEBPACK FOOTER //
// ./lib/rlink-recruiting/groupJobsByDepartment.js